import {useState} from "react";
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import DateAdapter from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

const useStyles = makeStyles({
  inputSearch:{
    textAlign: "center",
  }
})

const dateTheme = createTheme({
  palette: {
    secondary:{
      main: "#EA5B13",
      dark: "#EA5B13",
      contrastText: "#fff",
    }
  },
  typography: {
    fontFamily: 'Montserrat',
    fontWeightRegular: 500,
    fontSize: 14,
    color: "#4F4F4F",
  },
});

export default function BasicDatePicker({ customStyles, variant, handleChange }) {
  const classes = useStyles();
  const todayDate = new Date();
  const [value, setValue] = useState(todayDate);

  const handleDateChange = (newValue) => {
    setValue(newValue);
    handleChange(newValue);
  };

  return (
    <ThemeProvider theme={dateTheme}>
    <LocalizationProvider dateAdapter={DateAdapter}>
      <MobileDatePicker
      disableFuture
      //maxDate={todayDate}
      inputFormat="DD/MM/yyyy"
      value={value}
      onChange={handleDateChange}
      renderInput={(params) => <TextField {...params} variant={variant}  sx={customStyles} InputProps={{
        disableUnderline: true,
        classes: { input: classes.inputSearch },
        sx: {fontSize: {xs: "11px",md:"0.875rem"}, fontWeight: "500", lineHeight: "17.07px", height: customStyles.height || "20px"},
      }}/>}
    />
    </LocalizationProvider>
    </ThemeProvider>
  );
}
